// 通知公告
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="详情" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self"
          @reload="$reloadHandle"></editView>
      </el-tab-pane>
      <el-tab-pane label="公告" name="second">
        <div style="    height: 90vh; overflow: hidden;overflow-y: scroll;">
        <div class="main">
          <div v-for="item in list" class="annunciate" :key="item.id" @click="openEditDialog(item.id)">
            <div class="time">
              <div class="time_data">{{getDay(item.createTime)}}</div>
              <div class="time_year">{{getYearAndMonth(item.createTime)}}</div>
            </div>
            <div class="content">
              <div class="title">{{item.title}}</div>
            </div>
          </div>
        </div>
      </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import editView from './edit.vue';
import { initVxeTable } from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import { dictType, loadDictData } from "@/config/dictType";

export default {
  name: 'affiche',

  components: { editView, pager },
  data() {
    return {
      total: 0,
      activeName: 'second',
      dataId: 0,
      pageSizes: [10, 20, 100],
      gridData: {},
      showEdit: false,
      editViewDataUpdateFlag: false,
      vxeOption: {},
      searchProjectCode: '',
      searchProjectName: '',
      // 查询参数
      formData: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量
        projectCode: '',
        projectName: ''
      },
      list: [],
    };
  },
  computed: {

  },
  mounted() {
    this.loadData();
  },
  watch: {

  },
  methods: {
    loadData() {
      this.$http.post(api.basBulletin.getListDataUrl, {}).then(res => {
        this.list = res.data.data
      })
    },

    getDay(v) {
      let date = new Date(v)
      return date.getDate()
    },

    getYearAndMonth(v) {
      let date = new Date(v)
      return date.getFullYear() + '-' + (date.getMonth() + 1)
    },

    openEditDialog(id) {
      this.dataId = id
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },
  }
};
</script>
<style lang="scss">
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}


.main {

  display: flex;
  flex-wrap: wrap;

  .annunciate {
    width: 48%;
    margin-right: 2%;
    margin-top: 10px;
    display: flex;
    align-items: center;
    border: 1px solid #898989;
    border-radius: 5px;
  }

  .time {
    width: 100px;
    height: 80px;
    margin: 10px;
    background-color: #b4b4b4;
    color: #ffffff;
    padding: 5px 8px;
    text-align: center;

    .time_data {
      font-size: 30px;
    }

    .time_year {
      margin-top: 5px;
      font-size: 17px;
    }
  }

  .content {
    .title {
      font-size: 17px;
      color: #313131;
    }

    .details {
      margin-top: 5px;
      font-size: 14px;
      color: #b4b4b4;
    }
  }
}

.annunciate:hover {
  border: 1px solid #fff;
  background-color: #cbd6dc;

  .time{
    background-color: #00c4b3;
    // .time_data{
    //   font-size: 30px;
    // }
    // .time_year{
    //   margin-top: 5px;
    // font-size: 17px;
    // }
  }

  .content {
    .title {
      font-size: 17px;
      color: #000000;
    }

    .details {
      margin-top: 5px;
      font-size: 14px;
      color: #000000;
    }
  }

}</style>
